import Constants from '../../Constants';
import { CASE_TYPE_MAP } from '../../utils/enum';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import { useEasyModeContext } from '../../contexts/EasyModeContext';
import { getTodayAsDateInput, PARTY_COUNT_MAX, PARTY_COUNT_MIN } from '../../utils/easyModeValidation';
import XCountStepper from '../common/XCountStepper';
import XInput from '../common/XInput';
import XSelect from '../common/XSelect';
import EasyModeDateField from './EasyModeDateField';
import {
  fieldFullClasses,
  fieldNarrowClasses,
  fieldWideClasses,
  formGridClasses,
  requiredHintClasses,
  stepBodyClasses
} from './easyModeClasses';

const CASE_TYPE_OPTIONS = Object.values(CASE_TYPE_MAP);

const EasyModeIntakeStep = () => {
  const { intake } = useEasyModeContext();
  const {
    values,
    getFieldError,
    handleCaseInfoChange,
    handleFieldBlur,
    handlePlaintiffCountChange,
    handleDefendantCountChange
  } = intake;

  return (
    <div className={stepBodyClasses}>
      <p className={requiredHintClasses}>*Required fields</p>

      <div className={formGridClasses} data-tour={TOUR_TARGETS.EASY_MODE_CASE_FACTS}>
        <div className={fieldFullClasses}>
          <XInput
            label="Case Name (optional)"
            name="caseName"
            value={values.caseInfo.caseName}
            onChange={handleCaseInfoChange}
            onBlur={handleFieldBlur}
          />
        </div>

        <div className={fieldWideClasses}>
          <XSelect
            label="Case Type*"
            name="caseType"
            value={values.caseInfo.caseType}
            options={CASE_TYPE_OPTIONS}
            emptyOption="Select Case Type"
            onChange={handleCaseInfoChange}
            onBlur={handleFieldBlur}
            error={getFieldError({ name: 'caseType' })}
          />
        </div>

        <div className={fieldWideClasses}>
          <XSelect
            label="State Incident Occurred*"
            name="stateOfIncident"
            value={values.caseInfo.stateOfIncident}
            options={Constants.Dropdowns.States}
            emptyOption="Select State"
            onChange={handleCaseInfoChange}
            onBlur={handleFieldBlur}
            error={getFieldError({ name: 'stateOfIncident' })}
          />
        </div>

        <div className={fieldWideClasses}>
          <EasyModeDateField
            label="Date of Incident*"
            name="dateOfIncident"
            value={values.caseInfo.dateOfIncident}
            max={getTodayAsDateInput()}
            onChange={handleCaseInfoChange}
            onBlur={handleFieldBlur}
            error={getFieldError({ name: 'dateOfIncident' })}
          />
        </div>

        <div className={fieldNarrowClasses}>
          <XCountStepper
            label="Plaintiffs*"
            name="plaintiffCount"
            value={values.plaintiffCount}
            min={PARTY_COUNT_MIN}
            max={PARTY_COUNT_MAX}
            onChange={handlePlaintiffCountChange}
            error={getFieldError({ name: 'plaintiffCount' })}
          />
        </div>

        <div className={fieldNarrowClasses}>
          <XCountStepper
            label="Defendants*"
            name="defendantCount"
            value={values.defendantCount}
            min={PARTY_COUNT_MIN}
            max={PARTY_COUNT_MAX}
            onChange={handleDefendantCountChange}
            error={getFieldError({ name: 'defendantCount' })}
          />
        </div>
      </div>
    </div>
  );
};

export default EasyModeIntakeStep;
